// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__hmBX2","clogo":"logo_clogo__AsVSC","ctlogo":"logo_ctlogo__yj1tZ","contact":"logo_contact__5tukc"};